<script lang="ts">
  import { Button, CardBody, Col, Form, Input, Label } from "sveltestrap";
  import { ContactUs, Email, Message, SENDIT, YourMessage, YourName } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
</script>

<Col sm="12" lg="6" xl="8" md="12" class="xl-50 box-col-6">
  <Card
    cardProps="height-equal"
    cardHeaderprops="pb-0 d-flex justify-content-between align-items-center"
    headerTitle={ContactUs}
  >
    <div slot="contentbody" class="contact-form">
      <Form class="theme-form">
        <div class="form-icon">
          <i class="icofont icofont-envelope-open" />
        </div>
        <div class="mb-3">
          <Label for="exampleInputName">{YourName}</Label>
          <Input
            class="form-control"
            id="exampleInputName"
            type="text"
            placeholder="John Dio"
          />
        </div>
        <div class="mb-3">
          <Label class="col-form-label" for="exampleInputEmail1">{Email}</Label>
          <Input
            class="form-control"
            id="exampleInputEmail1"
            type="email"
            placeholder="Demo@gmail.com"
          />
        </div>
        <div class="mb-3">
          <Label class="col-form-label" for="exampleInputEmail1">{Message}</Label>
          <textarea
            class="form-control textarea"
            rows="3"
            cols="50"
            placeholder={YourMessage}
          />
        </div>
        <div class="text-sm-end">
          <Button>{SENDIT}</Button>
        </div>
      </Form>
    </div>
  </Card>
</Col>
